export default {
    'packing-lists': 'Listas de empaque',
    'the-packing-list': 'Lista de empaque',
    'add-a-packing-list': 'Agregar Lista de empaque',
    to: 'a',
    'packing-list': 'Lista de empaque',
}